//https://stackoverflow.com/questions/19669786/check-if-element-is-visible-in-dom
export function isElementVisible(element: HTMLElement) {
	const style = getComputedStyle(element)
	if (style.display === "none" || style.visibility !== "visible") {
		return false
	}
	if (typeof style.opacity === "number" && style.opacity < 0.05) {
		return false
	}

	const bounds = element.getBoundingClientRect()
	if (element.offsetWidth + element.offsetHeight + bounds.height + bounds.width === 0) {
		return false
	}
	const center = {
		x: bounds.left + element.offsetWidth / 2,
		y: bounds.top + element.offsetHeight / 2,
	}

	if (center.x < 0 || center.y < 0) {
		return false
	}
	if (center.x > (document.documentElement.clientWidth || window.innerWidth)) {
		return false
	}
	if (center.y > (document.documentElement.clientHeight || window.innerHeight)) {
		return false
	}

	let pointContainer: ParentNode | null = document.elementFromPoint(center.x, center.y)
	while (pointContainer) {
		if (pointContainer === element) return true
		pointContainer = pointContainer.parentNode
	}
	return false
}
